import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "gatsby";
import {PageLinks} from "../../common/page-links";
import ImageModule from "../../modules/image_module";
import ContentModule from "../../modules/content_module";

import "./Tiles.scss";

const TilesBlock = ({Module, GQLPage}) => {

    var imagename = "guides-and-resources.image.card_image"

    return (
        <React.Fragment>

            <Container>
                <Row>
                    <Col>
                        <div className={`tiles-inner text_under_image guide_resources`} id={Module.id}>
                            {Module?.title_content && <div className="heading_content"><ContentModule Content={Module?.title_content} /></div>}

                            <div className={`tiles-wrapper four`}>

                                    {Module?.guides_and_resources_module?.length > 0 && Module?.guides_and_resources_module?.map((item) => {

                                        let processedImages = JSON.stringify({});
                                        if (GQLPage?.imagetransforms?.image_Transforms) {
                                            processedImages = GQLPage?.imagetransforms?.image_Transforms;
                                        }

                                        return(

                                            <div className={`tiles_box`}>

                                                <Link to={`/${PageLinks.guides_resources}/${item.guides_resource.slug}`} className={`tiles_link`}>

                                                    <div className="tile_img">
                                                        <ImageModule ImageSrc={item.guides_resource.image} title={item.guides_resource.title} altText={item.guides_resource.title} imagetransforms={processedImages} ggfx_results={item.guides_resource?.ggfx_results} renderer="srcSet" imagename={imagename} strapi_id={item.guides_resource.id} classNames="banner_img" />  
                                                    </div>
                                                    
                                                                
                                                    <span className="trans_bg"></span>
                                                
                                                    <div className="tiles_content">
                                                        <h3>{item.guides_resource.title}</h3>

                                                    </div>
                                                </Link>

                                            </div>
 

                                        )
                                    })} 
                           
                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>

        </React.Fragment>
    );
};
export default TilesBlock;